import { parseNonEmptyStrings } from '~/utils/societePayloadBuilder/parseHelpers';

import { buildOptionalExpiresAt, payloadText, previewExpiresAt, previewRequiredValue } from '../payloadFields';

import { createDefaultPromoBannerCarouselState } from './defaults';
import type { LuxPlusPromoBanner, LuxPlusPromoBannerCarouselState } from './types';

function omitUndefined<T extends Record<string, unknown>>(value: T): Record<string, unknown> {
  return Object.fromEntries(Object.entries(value).filter(([, entry]) => entry !== undefined));
}

function buildPromo(promo: LuxPlusPromoBanner, preview: boolean): Record<string, unknown> {
  const expiresAt = preview ? previewExpiresAt(promo.expiresAt) : buildOptionalExpiresAt(promo.expiresAt);

  return omitUndefined({
    label: preview ? previewRequiredValue(promo.label) : payloadText(promo.label),
    title: preview ? previewRequiredValue(promo.title) : payloadText(promo.title),
    ctaText: preview ? previewRequiredValue(promo.ctaText) : payloadText(promo.ctaText),
    ctaLink: preview ? previewRequiredValue(promo.ctaLink) : payloadText(promo.ctaLink),
    ctaLinkType: promo.ctaLinkType,
    expiresAt,
    eligibleRegions: parseNonEmptyStrings(promo.eligibleRegions),
  });
}

export function buildPromoBannerCarouselPayload(state: LuxPlusPromoBannerCarouselState): Record<string, unknown> {
  return {
    promos: state.promos.map((promo) => buildPromo(promo, false)),
  };
}

export function buildPromoBannerCarouselPreviewPayload(
  state: LuxPlusPromoBannerCarouselState,
): Record<string, unknown> {
  const promos = state.promos.length > 0 ? state.promos : createDefaultPromoBannerCarouselState().promos;

  return {
    promos: promos.map((promo) => buildPromo(promo, true)),
  };
}

export function serializePromoBannerCarouselPayload(state: LuxPlusPromoBannerCarouselState): string {
  return JSON.stringify(buildPromoBannerCarouselPayload(state), null, 2);
}

export function serializePromoBannerCarouselPreviewPayload(state: LuxPlusPromoBannerCarouselState): string {
  return JSON.stringify(buildPromoBannerCarouselPreviewPayload(state), null, 2);
}

export function promoBannerCarouselPayloadDownloadFilename(): string {
  return 'luxplus-promo-banner-carousel-payload.txt';
}
